import { Item } from "~/components/glossaryBrands/types"
import CustomImage from "~/components/ui/CustomImage"

interface BrandCardProps {
  item: Item
}

export default function BrandCard({ item }: BrandCardProps) {
  return (
    <a
      href={item.url}
      aria-label={item.label}
      className='flex flex-col h-36 sm:h-40 overflow-hidden rounded-lg bg-[#F9F9F9] duration-300 hover:shadow-md hover:shadow-[#00000019]'
    >
      {!!item.backgroundImage && (
        <CustomImage
          className='w-full max-h-14 min-h-14 sm:max-h-16 sm:min-h-16 object-cover'
          src={item.backgroundImage}
          alt={`Imagem de fundo da marca ${item.label}`}
          width={330}
          height={68}
          loading='lazy'
          fetchPriority='low'
        />
      )}

      {!item.backgroundImage && (
        <div className='w-full max-h-14 min-h-14 sm:max-h-16 sm:min-h-16 bg-[#00000019]' />
      )}

      <div className='flex flex-col items-center -mt-11 sm:-mt-12 px-2 lg:px-4'>
        <div className='w-full max-w-[152px] min-w-[152px] sm:max-w-[190px] sm:min-w-[190px] h-[56px] sm:h-[70px] rounded-lg overflow-hidden flex items-center justify-center bg-white'>
          {!!item.logoImage && (
            <CustomImage
              className='min-h-full object-cover'
              src={item.logoImage}
              alt={`Imagem da marca ${item.label}`}
              width={190}
              height={70}
              loading='lazy'
              fetchPriority='low'
            />
          )}
        </div>

        <span
          className='mt-2 text-red-wine font-bold line-clamp-1 text-center'
          title={item.label}
        >
          {item.label}
        </span>

        <span
          className='mt-1 text-[#585858] text-xs line-clamp-2 text-center min-h-4'
          title={item.category}
        >
          {item.category}
        </span>
      </div>
    </a>
  )
}
